import { Component, OnInit, OnDestroy } from '@angular/core';
import { TimelineStore } from '../timeline.store';
import { Subscriber } from 'rxjs/Subscriber';
import { RecorderStore } from '../../stores/recorder.store';
import { TIMELINE_TICK_WIDTH } from '../../../constants';
import { nearestDividend } from '../../../shared/helpers/math.helpers';
import { Player } from '../../entities/player';
import { Recorder } from '../../entities/recorder';

@Component({
  selector: 'app-timeline-buttons',
  templateUrl: 'timeline-buttons.component.html',
  styleUrls: ['timeline-buttons.component.styl']
})
export class TimelineButtonsComponent implements OnInit, OnDestroy {
  public inButtonIsDisabled = false;
  public outButtonIsDisabled = false;

  private zoomChangeSubscriber: Subscriber<number>;

  constructor(
    public timelineStore: TimelineStore,
    public recorderStore: RecorderStore,
    private recorder: Recorder,
    private player: Player
  ) {
  }

  ngOnInit() {
    this.zoomChangeSubscriber = this.timelineStore.zoomChange
      .subscribe(() => this.onZoomChange());
  }

  ngOnDestroy() {
    this.zoomChangeSubscriber.unsubscribe();
  }

  private onZoomChange() {
    this.updateButtonStates();
  }

  private updateButtonStates() {
    this.outButtonIsDisabled = this.timelineStore.isMinZoom();
    this.inButtonIsDisabled = this.timelineStore.isMaxZoom();
  }

  onZoomOutButtonClick() {
    this.timelineStore.zoom /= 2;
  }

  onZoomInButtonClick() {
    this.timelineStore.zoom *= 2;
  }

  get startButtonIsDisabled(): boolean {
    return this.recorder.recording || this.player.playback || this.timelineStore.currentPosition === 0;
  }

  onStartButtonClick() {
    this.timelineStore.currentPosition = 0;
  }

  get endButtonIsDisabled(): boolean {
    return this.recorder.recording ||
      this.player.playback ||
      this.recorderStore.recordData.length === 0 ||
      this.timelineStore.currentPosition === this.recorderStore.recordData.length;
  }

  onEndButtonClick() {
    this.timelineStore.currentPosition = this.recorderStore.recordData.length;
  }

  get backwardButtonIsDisabled(): boolean {
    return this.timelineStore.currentPosition === 0;
  }

  onBackwardButtonClick() {
    const step = this.timelineStore.convertPixelsToMilliseconds(TIMELINE_TICK_WIDTH);
    const currentPosition = this.timelineStore.currentPosition;
    const roundedCurrentPosition = nearestDividend(this.timelineStore.currentPosition, step);

    if (currentPosition > roundedCurrentPosition) {
      this.timelineStore.currentPosition = roundedCurrentPosition;
    } else {
      this.timelineStore.currentPosition = roundedCurrentPosition - step;
    }
  }

  onForwardButtonClick() {
    const step = this.timelineStore.convertPixelsToMilliseconds(TIMELINE_TICK_WIDTH);
    const currentPosition = this.timelineStore.currentPosition;
    const roundedCurrentPosition = nearestDividend(this.timelineStore.currentPosition, step);

    if (currentPosition < roundedCurrentPosition) {
      this.timelineStore.currentPosition = roundedCurrentPosition;
    } else {
      this.timelineStore.currentPosition = roundedCurrentPosition + step;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-buttons/timeline-buttons.component.ts